import { Maybe, StateAssert } from '@csp/csp-common-model';
import { ConsentVideoContentModel } from '@csp/csp-web-content-definitions';
import { EnumUtil } from '@csp/csp-common-enum-util';
import { ConsentType } from '@csp/dmdp-api-user-dto';
import { ZonedDateTimeFactory, ZonedDateTimeFormatter } from '@csp/csp-common-date-util';
import { ConsentVideoEntry } from '../model/ConsentVideoEntry';

const getVersionPublishedDate = (content: ConsentVideoContentModel): Maybe<string> => {
  for (const attr of content.app_and_web_attributes ?? []) {
    if ('web' in attr && typeof attr.web?.date === 'string') {
      const date = attr.web.date as unknown as string;
      const zonedDateTime = ZonedDateTimeFactory.fromDateString(date);
      return ZonedDateTimeFormatter.toDisplayDateTimeString(zonedDateTime, zonedDateTime.zone);
    }
  }

  return undefined;
};

const from = (content: ConsentVideoContentModel): ConsentVideoEntry => {
  const consentType = EnumUtil.fromStringOrError<ConsentType>(content.consent_type, ConsentType);
  const videoUrl = content.video?.video?.url;
  StateAssert.isDefined(videoUrl, `Missing video url for content type: ${content.consent_type}`);

  const versionPublishedDate = getVersionPublishedDate(content);
  return {
    header: content.header,
    title: content.title,
    version: String(content.version),
    consentType,
    versionPublishedDate,
    videoUrl,
  };
};

export const ConsentVideoEntryMapper = {
  from,
};
